import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    root: {
        padding: '30px 16px',
    },
    title: {
        ...theme.typographyPresets.titleMedium,
        fontStyle: 'normal',
    },
    subtitle: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 14,
        lineHeight: '1.71',
        color: theme.colors.text.dark,
        marginBottom: 20,
    },
    error: {
        ...theme.typographyPresets.labelPrimary,
        color: 'red',
        marginTop: 5,
        marginBottom: 0,
    },
}))
